import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { routesConfig } from './config/routesConfig';

const AppRouter = () => {
  return <RouterProvider router={createBrowserRouter(routesConfig)} />;
};

export default AppRouter;
